import React from "react";

import ImportExportMenu from "Components/Common/DataImport/ImportExportMenu";
import { DataImportConfig } from "Components/Common/DataImport/dataImportFields";
import {
  exportCapacityAssessmentRatingsToCSV,
  importCapacityAssessmentRating,
} from "common/services/capacity-assessments.service";

const importConfig: DataImportConfig = {
  title: "Capacity Assessment Ratings",
  entityLabel: "capacity assessment rating",
  icon: "ri-star-line",
  templateFile: "capacity_assessment_ratings_import_template.csv",
  importFn: importCapacityAssessmentRating,
  fields: [
    {
      key: "name",
      label: "Name",
      required: true,
      hint: "Must be unique across capacity assessment ratings",
    },
    {
      key: "capacityAssessmentType",
      label: "Type of Assessment",
      required: true,
      hint: "Must match an existing capacity assessment type",
    },
    { key: "description", label: "Description" },
  ],
};

/** Import/export menu for the capacity assessment ratings table. */
const Import = ({ apiParams }: { apiParams?: any }) => (
  <ImportExportMenu
    resource="capacity-assessment-rating"
    config={importConfig}
    exportFn={exportCapacityAssessmentRatingsToCSV}
    exportFileName="Capacity_Assessment_Ratings_Export.csv"
    apiParams={apiParams}
  />
);

export default Import;
